import { SRJ_DIMENSIONS } from '../../shared/enums/srj_dimensions.enum';
import { SRJ_TOPIC } from '../../shared/enums/srj_topic.enum';
import { ISrjCompletedStep, ISrjCompletedStepBEModel } from '../../shared/interfaces/ISrjCompeltedStep';
import { IWizardSidenavItem } from '../../shared/interfaces/IWizardSidenavItem';
import { srjTopics } from './srjTopics';
import { IJourneyConfigStageItem } from '../../shared/interfaces/JourneyConfigStageItem';

export class SRJOperations {
  public static setUpSideNav(srjConfig: any[], completedSteps: ISrjCompletedStep[]): IWizardSidenavItem[] {
    return srjConfig.map(step => {
      const subItems = step.steps.map(item => ({
        id: item.stepId,
        completed: completedSteps.some(completedStep => completedStep.stepId === item.stepId),
      }));

      const stageItem: IWizardSidenavItem = {
        id: step.stageId,
        time: step.time,
        icon: step.icon,
        hiddenInNavigation: step.hiddenInNavigation,
        sub: subItems,
      };

      stageItem.completed = subItems.length > 0 ? this.isStageCompleted(stageItem, 'sub') : false;
      stageItem.progress = this.getStageProgress(stageItem, 'sub');

      return stageItem;
    });
  }

  public static getDimensionForTopic(topic: SRJ_TOPIC): SRJ_DIMENSIONS {
    return srjTopics.filter(s => s.topicTitle === topic || s.topicTitle === SRJ_TOPIC['topic'])[0].dimension;
  }

  public static setUpStageOverview(stages: IJourneyConfigStageItem[], completedSteps: ISrjCompletedStep[]): IJourneyConfigStageItem[] {
    const mappedStages = stages.map(stage => {
      return {
        ...stage,
        completed: false,
        progress: 0,
        steps: stage.steps.map(item => {
          return {
            ...item,
            completed: completedSteps.findIndex(s => s.stepId === item.stepId) > -1,
          };
        }),
      };
    });
    mappedStages.forEach(stage => {
      stage.completed = stage.steps.length > 0 ? this.isStageCompleted(stage, 'steps') : false;
      stage.progress = this.getStageProgress(stage, 'steps');
    });
    return mappedStages;
  }

  private static isStageCompleted(stage: IWizardSidenavItem | IJourneyConfigStageItem, propertyName: 'sub' | 'steps'): boolean {
    // if last step is completed - stage is completed
    return stage[propertyName][stage[propertyName].length - 1].completed;
  }

  private static getStageProgress(stage: IWizardSidenavItem | IJourneyConfigStageItem, propertyName: 'sub' | 'steps'): number {
    let stepsCompleted = 0;
    stage[propertyName].forEach(step => {
      if (step.completed) {
        stepsCompleted += 1;
      }
    });
    return (stepsCompleted / stage[propertyName].length) * 100;
  }

  public static mapStepDataFromBE(completedStep: ISrjCompletedStepBEModel): ISrjCompletedStep {
    return {
      stepId: completedStep.stepId,
      data: completedStep.userInput ? { value: completedStep.userInput.value } : null,
    };
  }

  public static mapStepDataFromFE(completedStep: ISrjCompletedStep): ISrjCompletedStepBEModel {
    const newStep: ISrjCompletedStepBEModel = {
      stepId: completedStep.stepId,
    };
    if (completedStep.data) {
      newStep.userInput = {
        inputName: completedStep.stepId,
        value: completedStep.data.value,
      };
    }
    return newStep;
  }

  public static getStep3_11i18nPrefix(completedSteps: ISrjCompletedStep[]): string {
    let oldRating = null;
    let newRating = null;
    let improved = false;
    if (completedSteps.findIndex(s => s.stepId === 'stage1_6') > -1) {
      oldRating = Number(completedSteps[completedSteps.findIndex(s => s.stepId === 'stage1_6')].data.value);
    }
    if (completedSteps.findIndex(s => s.stepId === 'stage3_10') > -1) {
      newRating = Number(completedSteps[completedSteps.findIndex(s => s.stepId === 'stage3_10')].data.value);
    }
    if (newRating > oldRating || (newRating === 5 && oldRating === 5)) {
      improved = true;
    }
    return improved ? 'srj.stages.stage3.steps.stage3_11.improved.' : 'srj.stages.stage3.steps.stage3_11.not-improved.';
  }
}
